const urlUtil = {
  getQueryVariable(variable) {
    var query = window.location.search.substring(1)
    var vars = query.split('&')
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split('=')
      if (pair[0] == variable) {
        return pair[1]
      }
    }
    return (false)
  },
  isIOS() {
    var ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1 || ua.indexOf('ipod') > -1
  },
  getSignUrl() {
    if (this.isIOS()) {
      return window.__wxEntryUrl || window.location.href.split('#')[0]
    }
    return window.location.href.split('#')[0]
  },
  setEntryUrl() {
    if (!window.__wxEntryUrl) {
      window.__wxEntryUrl = window.location.href.split('#')[0]
    }
  }
}

export default urlUtil



// WEBPACK FOOTER //
// ./src/utils/urlUtil.js